module.exports = __webpack_public_path__ + "media/icons/lock-2671d281.png";